import { getFixtureScore } from './leagueMatchdayAnalysis';
import { isFixtureEvaluationFinalized } from './fixtureFinalization';
import { canEvaluate } from './canEvaluate';

export const fixtureState = fixture => String(fixture?.state?.state || fixture?.state?.short_name || fixture?.state?.developer_name || (typeof fixture?.state === 'string' ? fixture.state : '')).toUpperCase();
export const finishedFixture = fixture => ['FT','FT_PEN','AET'].includes(fixtureState(fixture));
export const liveFixture = fixture => ['LIVE','INPLAY','1H','HT','2H','ET','BREAK','PEN_LIVE','INPLAY_1ST_HALF','INPLAY_2ND_HALF','INPLAY_ET','INPLAY_PENALTIES'].includes(fixtureState(fixture));
const finite = x => x != null && x !== '' && Number.isFinite(Number(x));
export const hasFixtureCompilation = fixture => [2,3,4,5].includes(Number(fixture?.status)) ||
  [fixture?.homewin,fixture?.draw,fixture?.awaywin].every(finite) ||
  [fixture?.probs?.homewin,fixture?.probs?.draw,fixture?.probs?.awaywin].every(finite) ||
  [fixture?.goalexp?.home,fixture?.goalexp?.away].every(finite);
export function fixtureKickoff(fixture) {
  if (fixture?.starting_at_timestamp) return Number(fixture.starting_at_timestamp)*1000;
  const raw=fixture?.starting_at;
  return raw ? Date.parse(/^\d{4}-\d\d-\d\d \d\d:/.test(raw) ? raw.replace(' ','T')+'Z' : raw) : NaN;
}
export function futureFixture(fixture, now=Date.now()) {
  return ['NS','TBA'].includes(fixtureState(fixture)) && fixtureKickoff(fixture)>now;
}
export function selectableDayFixture(fixture, mode, override=false, now=Date.now()) {
  if(isFixtureEvaluationFinalized(fixture))return false;
  if(mode==='evaluate')return canEvaluate(fixture) && finishedFixture(fixture) && !!getFixtureScore(fixture);
  return futureFixture(fixture,now) || (override && (liveFixture(fixture) || (finishedFixture(fixture) && !!getFixtureScore(fixture))));
}
export function automaticDaySelection(rows,mode,override=false,now=Date.now()) {
  return rows.filter(f=>selectableDayFixture(f,mode,override,now) &&
    (mode!=='compile' || !override || (finishedFixture(f) && !!getFixtureScore(f) && !hasFixtureCompilation(f))))
    .map(f=>f.id);
}

export function weekCompilationSelection(rows, override=false, onlyUncompiled=false, now=Date.now()) {
  return rows.filter(f => selectableDayFixture(f, 'compile', override, now) &&
    (!onlyUncompiled || !hasFixtureCompilation(f))).map(f => f.id);
}
